import $ from 'jquery';
import * as Favorites from '../../modules/favorite-products';

const SAVE_FAVES_BUTTON_SELECTOR = "#saveFaves";

$(function() {
    $(Favorites.FAV_BUTTON_SELECTOR).on("click", function (e) {
        let $button = $(this);
        let $modal = $(Favorites.MODAL_SELECTOR);
        let codes = $modal.data("codes") || "";
        let code = $button.data("code");

        if ($button.hasClass(Favorites.ACTIVE_CLASS)) {
            Favorites.sendUnfillToScreenReader($button);
            codes = codes.replace(code + ",", "");
        } else {
            Favorites.sendFillToScreenReader($button);
            codes += code + ",";
        }

        $button.toggleClass(Favorites.ACTIVE_CLASS);
        $modal.data("codes", codes);

        e.stopPropagation();
    });

    $(SAVE_FAVES_BUTTON_SELECTOR).on("click", function () {
        if (window.rcProps.isGuest) {
            Favorites.openModal();
        } else {
            $.post("/favorite-products/favorite/batch", $.param({
                codes: $(Favorites.MODAL_SELECTOR).data("codes") || ""
            }), function () {
                window.location.reload();
            });
        }
    });
});


// WEBPACK FOOTER //
// ./src/scripts/entry-points/favorites/index.js